import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { formatRut, validateRut } from 'rutlib';
import { DataNewUser } from '../interface/add-user.interface';
import { AddUsersService } from '../../service/add-users.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-modal-add',
  templateUrl: './modal-add.component.html',
  styleUrls: ['./modal-add.component.scss'],
})
export class ModalAddComponent {
  public form!: FormGroup;
  public userRut: number = 0;
  public validateRut: boolean = false;
  public chargeDinamic: boolean = false;
  public hide: boolean = true;
  public showSpinner: boolean = false;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialogRef<ModalAddComponent>,
    private user: AddUsersService
  ) {}

  contactType: any[] = [
    { value: 'admin', viewValue: 'Administrado' },
    { value: 'ejecutivo', viewValue: 'Ejecutivo' },
    { value: 'jefe', viewValue: 'Jefe' },
  ];

  ngOnInit(): void {
    this.form = this.fb.group(
      {
        firstName: ['', [Validators.required]],
        lastName: ['', [Validators.required]],
        phone: ['', [Validators.required]],

        email: [
          '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
          ],
        ],
        rut: ['', [Validators.required]],
        roles: ['', [Validators.required]],
        password: ['', [Validators.required]],
        confirmPassword: ['', Validators.required],
      },
      { validator: this.passwordMatchValidator }
    );
  }
  get f() {
    return this.form.controls;
  }

  passwordMatchValidator(g: FormGroup) {
    const password = g.get('password')!.value;
    const confirmPassword = g.get('confirmPassword')!.value;

    return password === confirmPassword ? null : { mismatch: true };
  }

  inputRut(): void {
    let userRut: string = this.form.controls['rut'].value!;
    const rutNumber = parseInt(userRut);
    const formattedRut: string = formatRut(userRut);
    this.form.controls['rut'].setValue(formattedRut);

    const cleanedRutWithoutDots = userRut.replace(/\./g, '');

    this.userRut = parseInt(
      cleanedRutWithoutDots.substring(0, cleanedRutWithoutDots.length - 1)
    );
    if (this.userRut >= 40000000) {
      this.form.controls['rut'].setErrors({ incorrect: true });
    }
    this.validateRut = validateRut(userRut);
    console.log(this.validateRut);
  }

  onSubmit() {
    const request: DataNewUser = {
      rut: this.form.value.rut,
      firstName: this.form.value.firstName,
      lastName: this.form.value.lastName,
      email: this.form.value.email,
      phone: this.form.value.phone,
      roles: this.form.value.roles,
      password: this.form.value.password,
    };
    let timerInterval: any;

    Swal.fire({
      text: 'Creando Usuario',
      icon: 'question',
      timerProgressBar: true,

      didOpen: () => {
        Swal.showLoading();
        this.user.addUser(request).subscribe({
          next: (res) => {
            Swal.fire({
              icon: 'success',
              title: 'Usuario Agregado!',
              showConfirmButton: false,
              timer: 4000,
            });
            this.dialog.close(this.chargeDinamic);
          },
          error: (err) => {
            Swal.fire({
              title: 'Error',
              text: '¡Hubo Error',
              icon: 'error',
              timerProgressBar: true,
            });
            console.log('Error', err);
          },
        });
      },
    });
  }
}
